// The one on/off control (UI review phase 2, Oct 2026): every true on/off in a
// settings row is drawn as the app's switch, the mixer's own. It stays a
// button with aria-pressed, so it reads as a toggle and is pressed like one;
// the row's label is its accessible name. A choice between named values stays
// a segmented control.

export function ToggleSwitch({
  on,
  onChange,
  label,
  disabled = false,
  title,
  testid,
}: {
  on: boolean;
  onChange: (on: boolean) => void;
  /** The setting's name, read with its state ("Bar numbers, pressed"). */
  label: string;
  disabled?: boolean;
  title?: string;
  testid?: string;
}) {
  return (
    <button
      type="button"
      className="toggle-switch"
      aria-pressed={on}
      aria-label={label}
      disabled={disabled}
      title={title}
      data-testid={testid}
      onClick={() => onChange(!on)}
    />
  );
}
